// @ts-nocheck
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'components/form';
import {
  Footer,
  FormContainer,
} from 'components/grid/list/components/form-filters/style';
import { omit, noop } from 'lodash';
import { set } from 'lodash/fp';

class FormFilters extends Component<any> {
  static type = 'filtersComponent';

  static propTypes = {
    children: PropTypes.func.isRequired,
    validationSchema: PropTypes.object,
    initialValues: PropTypes.object,
    searchFields: PropTypes.string,
    display: PropTypes.oneOf(['row', 'column']),
    prepareData: PropTypes.func,
    filter: PropTypes.object,
    setFilter: PropTypes.func,
  };

  static defaultProps = {
    validationSchema: undefined,
    initialValues: {},
    searchFields: '',
    display: 'column',
    prepareData: (data) => data,
    filter: {},
    setFilter: noop,
  };

  state = {
    __formReset: null,
  };

  onSubmit = (values) => {
    const data = omit(this.props.prepareData(values), ['__formReset']);
    this.props.setFilter(data);
  };

  reset = () => {
    // Hack so that we can trigger formik to reset form in case where user was clicking on form but has not applied filters. Without this we cannot set form to inital values.
    this.setState({ __formReset: new Date() }, this.props.setFilter);
  };

  initialValues = () => {
    const { filter, initialValues, searchFields } = this.props;

    return set('search.fields', searchFields, {
      ...initialValues,
      ...filter,
      __formReset: this.state.__formReset,
    });
  };

  render() {
    const { validationSchema, children, display } = this.props;

    return (
      <Form
        enableReinitialize
        initialValues={this.initialValues()}
        validationSchema={validationSchema}
        onSubmit={this.onSubmit}
        render={({ values, handleSubmit, setFieldValue }) => {
          return (
            <FormContainer display={display} data-type="list-filters">
              {children({
                filter: values,
                apply: handleSubmit,
                reset: this.reset,
                setFieldValue,
              })}
            </FormContainer>
          );
        }}
      />
    );
  }
}

FormFilters.Footer = Footer;

export default FormFilters;
